import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../assets/logo.webp';

const Logo: React.FC = () => {
  const { i18n } = useTranslation();

  return (
    <div className={`flex items-center gap-3 ${i18n.language === 'ar' ? 'flex-row-reverse' : ''} hover:scale-105 transition-transform duration-300`}>
      <img
        src={logo}
        alt="CoJeCo Logo"
        className="h-12 w-12 rounded shadow-md bg-white p-1"
      />
      <span className="font-serif text-xl md:text-3xl font-bold tracking-wide text-white">
        <span>Co</span>
        <span>Je</span>
        <span>Co</span>
      </span>
    </div>
  );
};

export default Logo;